import script from "./AndroidApi.vue?vue&type=script&setup=true&lang=js"
export * from "./AndroidApi.vue?vue&type=script&setup=true&lang=js"

import "./AndroidApi.vue?vue&type=style&index=0&id=4633ba1c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4633ba1c"]])

export default __exports__